import { provideSingleton, lazyInject } from './inversify';
import { ApiService } from './api_service';
// import { StructureService } from './structure_service';
import { LocalDataService } from './local_data_service';
import { IDs } from '../helpers/IDs';
import { Versionen } from '../helpers/versionen';

export class Names {

}

@provideSingleton(DataService) // Diese Zeile definiert die Klasse bzw. eine Instanz davon als Service

export class DataService {

    public fileSizeCheck = true;
    public fileSizeLimit = 20971520; // 3145728;
    public fileSizeInfo = '20 MB'; // 3 MB
    public sendDirect = true;

    constructor() {
        this.checkServer = this.checkServer.bind(this);
        this.getItemCountInQueue = this.getItemCountInQueue.bind(this);
        this.getServerState = this.getServerState.bind(this);
        this.timer = setInterval(this.checkServer, 60000);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    // @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(LocalDataService) private localDataService: LocalDataService;

    private debug = false; // ****** DEBUG FLAG FÜR BUILD AUF FALSE SETZEN ********
    private version_info_shown = false;


    private saveQueueName = 'saveQueue';
    private timer: any;
    private saveRunning = false;
    private override = 1;

    // *********************************************************************************************************************
    // ********************************************** LOAD UND SAVE ********************************************************
    // *********************************************************************************************************************

    async async_loadData(entityName: string, filter: any, settings: any, module?: string, type?: string, bereich_key?: string) {
        const result = await this.apiService.async_call(
            'getData',
            {
                entity: entityName,
                filter,
                settings,
                override: 1,
                module,
                bereich_key
            }
        );
        let obj: any;
        try {
            obj = JSON.parse(result);
        } catch (e) {
            console.error(result, e);
        }
        return obj;
    }

    loadData(entityName: string, filter: any, settings: any, callback: (result: any, entityName: string, type: string) => void,
        module?: string, type?: string, bereich_key?: string, retry = 3) {
        const conf = require('../wips.config');
        this.apiService.call(
            'getData',
            {
                entity: entityName,
                filter: filter,
                settings: settings,
                override: 1,
                module,
                bereich_key
            },
            (json: string, suc: boolean) => {
                if (suc && json) {
                    let obj: any;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(json, e);
                    }
                    callback(obj, entityName, type);   // Achtung, nun strukturiert, ggf. mit bundle
                } else {
                    console.error(json);
                    console.log({ entityName, filter, settings, callback, module, type, bereich_key, retry });
                    if (retry > 0) {
                        console.log('Retry:', retry);
                        this.loadData(entityName, filter, settings, callback, module, type, bereich_key, retry - 1);
                    } else {
                        if (!conf.disableErrorCatching) {
                            alert('Es ist ein Serverfehler aufgetreten. Aktualisieren Sie bitte Ihre Internetseite!');
                        }
                        callback(undefined, entityName, type);
                    }
                }
            }
        );
    }

    batchLoadData(calls: Array<any>, module: string, callback: (data: any) => void, retry = 3) {
        const conf = require('../wips.config');
        this.apiService.call('batchGetData', { calls, module, override: 1 }, (json: string, suc: boolean) => {
            // console.log(json, suc);
            if (suc && json) {
                let obj: any;
                try {
                    obj = JSON.parse(json);
                } catch (e) {
                    console.error(json, e);
                }
                callback(obj);
            } else {
                console.error(json);
                console.log({ calls, callback, retry });
                if (retry > 0) {
                    console.log('Retry:', retry);
                    this.batchLoadData(calls, module, callback, retry - 1);
                } else {
                    if (!conf.disableErrorCatching) {
                        alert('Es ist ein Serverfehler aufgetreten. Aktualisieren Sie bitte Ihre Internetseite!');
                    }
                    callback(undefined);
                }
            }
        });
    }

    loadDataForModul(entityName: string, filter: any, settings: any, modul: string, callback: (result: ReadonlyArray<any>) => void) {
        return this.loadDataForModulCustom('getData', entityName, filter, settings, modul, callback);
    }

    loadBundleForModul(entityName: string, modul: string, callback: (result: any) => void) {
        // Dient zur Lade vom Bundle
        return this.loadDataForModulCustom('getData', entityName, { tid: 0 }, { bundle: true }, modul, callback);
        // return this.loadDataForModulCustom('getData', entityName, { tid: 0 }, { bundle: true }, modul, (result: any) => {
        //     // Lade In-line-Bundle
        //     const struc = this.structureService.getStructureByKey(modul, entityName);
        //     if (struc && Array.isArray(struc.ATTS)) {
        //         struc.ATTS.filter((att: any) => att.OPTS && !att.OPTS.ENTITY && Array.isArray(att.OPTS))
        //             .forEach((att: any) => {
        //                 if (result.bundle && !result.bundle[att.KEY]) {
        //                     result.bundle[att.KEY] = att.OPTS.map((op: any) => {
        //                         return { tid: op.VALUE, name: op.TITEL };
        //                     });
        //                     // console.log(att.KEY, result.bundle[att.KEY]);
        //                 }
        //             });
        //     }
        //     callback(result);
        // });
    }

    loadHilfeData(entiyName: string, filter: any, lang: string, modul: string, callback: (result: ReadonlyArray<any>) => void) {
        this.apiService.call('getHilfe', {
            entity: entiyName,
            filter,
            module: modul,
            lang,
            override: 1
        }, (data: string, suc: boolean) => {
            if (suc) {
                let result: ReadonlyArray<any>;
                try {
                    result = JSON.parse(data);
                } catch (e) {
                    console.error(data, e);
                }
                callback(result);   // Achtung, nun strukturiert, ggf. mit bundle
            }
        }
        );
    }

    setHilfeData(entityName: string, data: any, lang: string, callback: (success: boolean) => void) {
        this.apiService.call('setHilfe', { entity: entityName, data: data, override: 1, lang, module: IDs.MOD_ETOOL_ADMIN }, (result: string, suc: boolean) => {
            if (suc) {
                if (result === 'true') {
                    callback(suc);
                } else {
                    callback(false);
                }
            }
        });
    }

    delHilfe(entityName: string, filter: any, callback: (suc: boolean) => void) {
        this.apiService.call('deleteHilfe', { entity: entityName, filter: filter, override: 1, module: IDs.MOD_ETOOL_ADMIN }, (data: string, suc: boolean) => {
            if (suc) {
                callback(suc);
            }
        });
    }

    setPdf(entityName: string, data: any, callback: (result: any) => void) {
        this.apiService.call('setPdf', { entity: entityName, data: data, override: 1 }, (result: string, suc: boolean) => {
            if (suc) {
                let path: ReadonlyArray<any>;
                try {
                    path = JSON.parse(result);
                } catch (e) {
                    console.error(data, e);
                }

                callback(path);
            }
        });
    }

    delOldPdf(entityName: string, data: any, callback: (result: any) => void) {
        this.apiService.call('delPdf', { entity: entityName, data, override: 1 }, (result: string, suc: boolean) => {
            if (suc) {
                callback(result);
            }
        });
    }

    copyInhalt(data: any, callback: (result: any) => void) {
        this.apiService.call('inhaltCopy', { data, override: 1 }, (result: string, suc: boolean) => {
            if (suc) {
                let res;
                try {
                    res = JSON.parse(result);
                } catch (e) {
                    console.error(data, e);
                }

                callback(res);
            }
        });
    }

    delAntrag(data: any, callback: (result: any) => void) {
        this.apiService.call('deeploeschen', { data, override: 1 }, (result: string, suc: boolean) => {
            if (suc) {
                callback(result);
            }
        });
    }

    antragReinigung(data: any, callback: (result: any) => void) {
        this.apiService.call('deepreinigung', { data, ovverride: 1 }, (result: string, suc: boolean) => {
            if (suc) {
                let res;
                try {
                    res = JSON.parse(result);
                } catch (e) {
                    console.error(data, e);
                }

                callback(res);
            }
        });
    }

    loadDataForModulCustom(
        call: string,
        entityName: string,
        filter: any,
        settings: any,
        modul: string,
        callback: (result: ReadonlyArray<any>) => void) {
        this.apiService.call(
            call,
            {
                entity: entityName,
                module: modul,
                override: 1,
                filter: filter,
                settings: settings,
            },
            (data: string, suc: boolean) => {
                if (suc) {
                    let result: ReadonlyArray<any>;
                    try {
                        result = JSON.parse(data);
                    } catch (e) {
                        console.error(data, e);
                    }
                    callback(result);   // Achtung, nun strukturiert, ggf. mit bundle
                }
            }
        );
    }
    loadBackupForModul(entityName: string, backupTid: number, modul: string, backupEntityName: string,
        callback: (result: ReadonlyArray<any>) => void) {
        this.apiService.call('getBackupEntity',
            {
                entity: entityName,
                module: modul,
                backupTid: backupTid,
                backupEntity: backupEntityName,
                override: 1,
            }, (data: string, suc: boolean) => {
                if (suc) {
                    let result: ReadonlyArray<any>;
                    try {
                        result = JSON.parse(data);
                    } catch (e) {
                        console.error(data, e);
                    }

                    callback(result);   // Achtung, nun strukturiert, ggf. mit bundle
                }
            });
    }
    delData(entityName: string, module: string, filter: any, settings: any, callback: (result: ReadonlyArray<any>, suc?: boolean) => void) {
        this.apiService.call('delData',
            {
                entity: entityName,
                filter: filter,
                module: module,
                override: 1,
                settings: settings,
            }, (data: string, suc: boolean) => {
                if (suc) {
                    let result: ReadonlyArray<any>;
                    try {
                        result = JSON.parse(data);
                    } catch (e) {
                        console.error(data, e);
                    }
                    callback(result, suc);   // Achtung, nun strukturiert, ggf. mit bundle
                }
            });
    }

    saveBackupForModul(entityName: string, modul: string, schittname: string, backupEntityName: string, backUpData: any,
        callback: (data: string, suc: boolean) => void) {
        this.apiService.call('backupEntity',
            {
                entity: entityName,
                schnittname: schittname,
                module: modul,
                data: backUpData,
                backupEntity: backupEntityName,
                override: 1,
            }, callback
        );
    }

    recoverBackup(entityName: string, modul: string, bTid: number, backupEntityName: string,
        callback: (data: string, suc: boolean) => void) {
        this.apiService.call('recoverBackup',
            {
                entity: entityName,
                module: modul,
                backupTid: bTid,
                backupEntity: backupEntityName,
                override: 1
            }, callback
        );
    }
    delDataList(entityName: string, itemList: Array<any>, callback: () => void, module?: string) {
        if (!module) {
            module = IDs.MOD_ETOOL;
        }
        if (!itemList || itemList.length === 0) {
            // Nichts zu tun
            callback();
            return;
        }
        console.log('Lösche Datensätze: ', itemList);
        this.apiService.call('delDataList', { entity: entityName, dataList: itemList, override: 1, module }, callback);
    }
    clearEntity(entityName: string, callback: () => void) {
        if (!entityName || entityName === '') {
            // Nichts zu tun
            callback();
            return;
        }
        this.apiService.call('clearEntity', { entity: entityName, override: 1 }, callback);
    }

    saveBilder(entity: string, imgList: Array<any>, callback: (data: string, suc: boolean) => void) {
        this.apiService.call('setPicForHelp', { entity: entity, module: 'core', data: imgList, override: 1 }, callback);
    }

    saveDataList(entityName: string, itemList: Array<any>, callback: (sqlSuc: string, suc: boolean) => void,
        module: string, clear?: number) {
        // console.log(entityName, itemList);
        this.apiService.call('setDataList',
            {
                override: 1,
                entity: entityName,
                dataList: itemList,
                disableProcess: 1,
                module,
                clear
            },
            (sqlSuc: string, suc: boolean) => {
                if (parseInt(sqlSuc, 0) === 0) {
                    suc = false;
                }
                callback(sqlSuc, suc);
            });
    }

    updateDataSingle(entityName: string, tid: number, values: any, callback: (suc: boolean) => void, module: string) {
        console.log('updateSingle', entityName);
        this.loadData(entityName, { tid: tid }, {}, (result: any) => {
            console.log('updateDataSingle:', result);
            if (!result || !result[entityName]) {
                callback(false);
                return;
            }
            const dataArr = result[entityName];
            if (dataArr.length === 0) {
                callback(false);
                return;
            }
            const item = dataArr[0];
            Object.keys(values).forEach((key: string) => item[key] = values[key]);
            this.saveData(entityName, item, undefined, false, (suc: boolean) => {
                callback(suc);
            }, module);

        }, module);
    }

    saveData(entityName: string, itemData: any, tableId: string, setHistorie: boolean, callback: (suc: boolean, saveTid: number) => void,
        module: string = undefined, type?: string) {
        if (entityName === IDs.ENT_KONFIGURATION) {
            // console.trace('SAVE KONFIG: ', itemData);
        }
        const item = {
            entity: entityName,
            module: module,
            data: itemData,
            tableId,
            setHistorie
        };
        if (this.sendDirect) {
            this.apiService.call('setData', { ...item, override: 1 }, (data: string, suc: boolean) => {
                // console.log(item, data);
                if (suc) {
                    const saveTid: number = isNaN(parseInt(data, 10)) ? -1 : parseInt(data, 10);
                    callback(suc, saveTid);
                } else {
                    callback(suc, -1);
                }
            });
            return;
        }

        if (entityName) {   // Item erzeugen und in saveQueue ablegennpm updat
            this.localDataService.add(this.saveQueueName, item);
        }
        // Callback für "setData"-Call erzeugen
        const internalCallback = (data: string, suc: boolean) => {
            if (!suc) {
                callback(suc, -1);  // Wenn nicht erfolgreich einfach zurückmelden
                this.saveRunning = false;
            } else {
                const restCnt = this.localDataService.removeFirst(this.saveQueueName);    // Erfolgreich gesendeten Datensatz entfernen
                // console.log('REST-CNT: ' + restCnt);
                if (restCnt > 0) {
                    const nextItem = this.localDataService.getFirst(this.saveQueueName);
                    if (nextItem) {
                        window.setTimeout(() => { this.apiService.call('setData', { ...nextItem, override: 1 }, internalCallback); }, 10);
                    }
                } else {
                    this.saveRunning = false;
                    const saveTid: number = isNaN(parseInt(data, 10)) ? -1 : parseInt(data, 10);
                    callback(suc, saveTid);
                }
            }
        };
        // Erstes item holen ....
        const firstItem = this.localDataService.getFirst(this.saveQueueName);
        // und setData aufrufen
        this.saveRunning = true;
        this.apiService.call('setData', { ...firstItem, override: 1 }, internalCallback);
    }

    setData(module: string, entity: string, data: any, callback?: (insertID: number, callbackParams?: any) => void, callbackParams?: any) {
        this.apiService.call('setData',
            {
                entity,
                module,
                data,
                override: this.override
            },
            (json: string, success: boolean) => {
                // console.log(json, success);
                if (typeof callback === 'function') {
                    let insertID = -1;
                    if (success) {
                        try {
                            insertID = JSON.parse(json);
                        } catch (e) {
                            console.error(e, json);
                        }
                    }
                    callback(insertID, callbackParams);
                }
            }
        );
    }

    saveDataWithInsertID(module: string, entity: string, data: any, callback?: (insertID: number) => void) {
        this.apiService.call(
            'setData',
            {
                entity,
                module,
                data,
                override: this.override
            },
            (queryRes: string, callSuc: boolean) => {
                // console.log(queryRes, callSuc);
                if (typeof callback === 'function') {
                    let insertID = -1;
                    if (callSuc) {
                        try {
                            insertID = JSON.parse(queryRes);
                        } catch (e) {
                            console.error(e, queryRes);
                        }
                    }
                    callback(insertID);
                }
            }
        );
    }

    getTableHistorie(module: string, entity: string, tableId: string, callback: (data: string, suc: boolean) => void) {
        this.apiService.call('getTableHistorie', { module, entity, tableId, override: 1 }, callback);
    }

    setTableStore(entity: string, tableId: string, data: any, comment: string, callback: (data: string, suc: boolean) => void) {
        this.apiService.call('setTableStore', { entity, tableId, data, comment, override: 1 }, callback);
    }

    getTableStore(entity: string, tableId: string, callback: (data: string, suc: boolean) => void) {
        this.apiService.call('getTableStore', { entity, tableId, override: 1 }, callback);
    }

    delTableStore(tid: number, callback: (data: string, suc: boolean) => void) {
        this.apiService.call('delTableStore', { tid, override: 1 }, callback);
    }

    loadAnzahl(key: string, callback: (anzahl: number) => void) {
        this.apiService.call(key, {}, (data: string, suc: boolean) => {
            if (suc) {
                let result: ReadonlyArray<number>;
                try {
                    result = JSON.parse(data);
                } catch (e) {
                    console.error(data, e);
                }
                const indexName: any = 'anzahl';
                const anzahl: number = result[indexName];
                callback(anzahl);
            }
        });
    }
    // ********************** RESSOURCEN ***********************************************
    getRessourceInfo(path: string, mode: string, callback: (infoObj: any) => void, module?: string) {
        this.apiService.call('getRessource', { path: path, mode: mode, override: 1, getFileInfo: true, module }, (data: string, suc: boolean) => {
            if (suc) {
                let obj;
                try {
                    obj = JSON.parse(data);
                } catch (e) {
                    // console.error(e);
                }
                callback(obj);
            }
        }, module);
    }

    loadRessource(path: string, mode: string, callback: (data: string) => void, module?: string) {
        this.apiService.call('getRessource', { path: path, mode: mode, override: 1 }, (data: string, suc: boolean) => {
            if (suc) {
                callback(data);
            }
        }, module);
    }

    saveRessource(file: any, filename: string, entity: string, modul: string, callback: (data: string) => void) {
        this.apiService.call('saveRessource',
            {
                file: file,
                filename: filename,
                entity: entity,
                module: modul,
                override: 1
            },
            (data: string, suc: boolean) => {
                if (suc) {
                    callback(data);
                }
            });
    }

    afterSaveRessource(filename: string, entity: string, modul: string, callback: (data: string) => void, email?: boolean) {
        this.apiService.call('afterSaveRessource', {
            filename: filename,
            entity: entity,
            module: modul,
            email: email,
            override: 1
        },
            (data: string, suc: boolean) => {
                if (suc) {
                    callback(data);
                }
            }
        );
    }

    loadParameterTermine(modul: string, callback: (param: any) => void) {
        const entity = 'application_parameter';
        this.loadDataForModul(
            entity, {}, {}, modul,
            (result: any) => {
                if (Array.isArray(result[entity])) {
                    const param: any = {};
                    result[entity].map((r: any) => {
                        if (typeof r.parameter_key === 'string' && r.parameter_key.startsWith('termine.') && r.value) {
                            param[r.parameter_key] = parseInt(r.value, 10);
                        }
                    });
                    callback(param);
                }
            }
        );
    }

    loadParameterAntragVerfall(modul: string, callback: (param: any) => void) {
        const entity = 'application_parameter';
        this.loadDataForModul(
            entity, {}, {}, modul,
            (result: any) => {
                if (Array.isArray(result[entity])) {
                    const param: any = {};
                    result[entity].map((r: any) => {
                        if (typeof r.parameter_key === 'string' && r.parameter_key.startsWith('antrag.verfall') && r.value) {
                            param[r.parameter_key] = parseInt(r.value, 10);
                        }
                    });
                    callback(param);
                }
            }
        );
    }

    // *********************************************************************************************************************
    // ********************************************** QUEUE STATUS, SERVER STATUS, SERVER CHECK ****************************
    // *********************************************************************************************************************

    getItemCountInQueue() {
        return this.localDataService.count(this.saveQueueName);
    }
    getServerState() {
        return this.apiService.getServerState();
    }
    checkServer() {
        this.apiService.call('getTime', {}, (data: string, suc: boolean) => {
            // console.log('Check-Server: ' + suc);
            if (!data || !suc) {
                return;
            }
            const split = data.split(';');
            if (split.length > 1) {
                const version_expected = split[1];
                const version_local = Versionen.VERSION;
                if (!window.location.href.startsWith('http://localhost') &&
                    version_expected && version_expected !== version_local && !this.version_info_shown) {
                    const info = 'Die Version des E-Tools wurde aktualisiert (' + version_local + ' => ' + version_expected + ') ' +
                        'soll das E-Tool nun neu geladen werden? Falls nicht, empfehlen wir sobald möglich manuelle neu zu laden';
                    if (window.confirm(info)) {
                        this.apiService.setTokenLocalStorage();
                        const currentPage = new URL(window.location.href);
                        currentPage.searchParams.set('t', (new Date().getTime()) + '');
                        window.location.href = currentPage.href;
                    } else {
                        this.version_info_shown = true;
                    }

                }
            }
            if (suc && this.getItemCountInQueue() > 0 && !this.saveRunning) {
                this.saveData(null, null, null, null, (sucSave: boolean) => {
                    if (sucSave) {

                    }
                }, undefined, '');
            }
        });
    }
}
